"use strict"

import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import { localizeTimeExtractor } from "./ToggleTimeExtractor"
import TIME_EXTRACTORS from "../../resources/TimeExtractors"
import { isLTPM } from "../../../../components/shared_components_registration"
import { withPlotSettingsConfig } from "../../../config/PlotSettingsConfigProvider"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  choose_align_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.align", description: "Align X-Axis Label" }) : "Align",
}

const ToggleAxisAlignment = ({
  intl,
  timeExtractor, // From PlotSettingsProvider
  updateSettings, // From PlotSettingsProvider
  showLabel,
  alignment,
  dropToggleClass = "",
}) => {
  return (
    <>
      {timeExtractor.name === "Timestamp" && (
        <>
          {showLabel && <label className={"text-center"}>{registration.choose_align_label(intl)}:</label>}
          <DropdownButton
            variant={"outline-primary"}
            id={"xaxisalign"}
            title={localizeTimeExtractor(intl, alignment, true)}
            className={dropToggleClass}
          >
            {TIME_EXTRACTORS.map((te, i) => (
              <Dropdown.Item
                key={i}
                eventKey={te}
                onClick={() =>
                  te !== alignment &&
                  updateSettings({
                    alignment: te,
                  })
                }
                style={te === alignment ? { backgroundColor: "var(--lanzalake-grey)" } : {}}
              >
                {localizeTimeExtractor(intl, te, false)}
              </Dropdown.Item>
            ))}
          </DropdownButton>
        </>
      )}
    </>
  )
}

export default withPlotSettingsConfig(ToggleAxisAlignment)
